import React from 'react'
import { InfiniteScroller, ResponsiveTableRow, colors } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { MePersonLink, PersonLink } from '../../app/Links'

const PersonsResponsiveTable = ({ personsState, personsActions, state, getUserName, t, TableHeaders }) => {
  const startingStyle = css`
    color: ${colors.green20};
  `

  return (
    <>
      <DmcResponsiveTable id="personsTable" totalColumnCount={6} separator=" " atSizeColumns={TableHeaders}>
        {personsState?.persons?.persons?.map((person) => {
          const firstName = person?.summary?.nameForms[0].parts.find(
            (part) => part.type === 'http://gedcomx.org/Given'
          )?.value
          const lastName = person?.summary?.nameForms[0].parts.find(
            (part) => part.type === 'http://gedcomx.org/Surname'
          )?.value
          return (
            <ResponsiveTableRow
              key={person.id}
              column1={<PersonLink personId={person.id} showId={false} newTab />}
              column2={firstName}
              column3={lastName}
              column4={t(`gender.${person.summary.gender}`, person.summary.gender)}
              column5={person.summary.lifespan}
              column6={
                <>
                  <MePersonLink
                    cisId={person.summary.mePersonCisId}
                    userName={getUserName(person.summary.mePersonCisId)}
                  />
                  {person.id === state.tree?.startingPersonId ? (
                    <span css={startingStyle}>{t('tree.starting', 'Starting')}</span>
                  ) : (
                    ''
                  )}
                </>
              }
            />
          )
        })}
      </DmcResponsiveTable>
      <InfiniteScroller fetchMore={personsActions.fetchMorePersons} />
    </>
  )
}

export default PersonsResponsiveTable
